/* ==========================================================================
   Saunt — video hero controls.

   THE FAULT

   sections/video-hero.liquid is built for a DECORATIVE background video, and
   two separate things stop its native controls from ever being usable:

     1. an inline <style> block sets
          #shopify-section-template--XXXX__video-hero video {
            pointer-events: none !important;
          }

     2. .banner__media carries z-index: -1, which pushes the whole media
        subtree behind the .banner element. Any z-index set on the video is
        trapped inside that stacking context and cannot climb out, so .banner
        wins every hit test regardless.

   Together: the control bar renders, and absolutely nothing reaches it. On a
   phone this reads as controls that are simply dead.

   WHY CSS CANNOT FIX IT

   Fault 1 uses an ID selector with !important. An ID outranks any number of
   attribute or class selectors, and the section ID regenerates on every theme
   duplication so it cannot be hardcoded in a stylesheet. The only
   author-origin declaration that beats it is an inline style with !important,
   which has to be set from script. Fault 2 is fixed here too rather than in
   CSS, so a future specificity change cannot silently break it again.

   Raising .banner__media out of the negative layer is safe for this section
   because show_text_box is false — there is no text overlay that needs to sit
   above the media. If a text box is ever enabled here, revisit this.

   WHAT THIS REPLACES

   Two inline blocks in layout/theme.liquid:
     - setInterval(forceVideoControls, 500), running forever on every page of
       the site setting controls = true. The controls were never missing, so
       it treated a symptom that did not exist.
     - an injected .video-hero-unmute-btn, appended to the SECTION rather than
       the video, which on desktop floated in empty space beside it. The
       section already provides .video-hero__sound-toggle.

   Both are gone. This runs once per render, no polling.
   ========================================================================== */

(function () {
  'use strict';

  var SECTION = '[id^="shopify-section-"][id$="__video-hero"]';

  function enable(section) {
    var video = section.querySelector('video');
    if (!video || video.dataset.sauntVideoHero) return;

    // Inline + important is the only thing that outranks the section's own
    // ID-selector rule.
    video.style.setProperty('pointer-events', 'auto', 'important');

    video.controls = true;
    video.removeAttribute('controlslist');

    // Lift the media out of the negative stacking layer, otherwise the
    // video is behind .banner and unreachable no matter what it is set to.
    var media = section.querySelector('.banner__media');
    if (media) media.style.setProperty('z-index', 'auto', 'important');

    video.dataset.sauntVideoHero = 'enabled';
  }

  function run() {
    try {
      var sections = document.querySelectorAll(SECTION);
      for (var i = 0; i < sections.length; i++) enable(sections[i]);
    } catch (error) {
      if (window.console) console.error('[saunt-video-hero]', error);
    }
  }

  run();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  }

  // The video can be swapped in after load, and the theme editor re-renders
  // sections in place.
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);

  if (window.MutationObserver) {
    var target = document.getElementById('MainContent') || document.body;
    if (target) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            run();
            return;
          }
        }
      }).observe(target, { childList: true, subtree: true });
    }
  }
})();
